<ng-content></ng-content>

<cm-inspector-section>
    <ng-container cm-title> Render </ng-container>
    <ng-container cm-content>
        <cm-value-slot
            [node]="$node()"
            [key]="'percentage'"
            [label]="'%'"
            [decimalPlaces]="0"
            [min]="0"
            [max]="100"
            [numberModifier]="'arrows'"
        ></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'samples'" [label]="'Samples'" [decimalPlaces]="0"></cm-value-slot>
        <cm-value-slot
            [node]="$node()"
            [key]="'textureStreaming'"
            [label]="'Texture Tiles'"
            [selectionPossibilities]="$textureStreamingPossibilities()"
            [fallbackText]="'Default'"
        ></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'renderTiling'" [label]="'Render Tiling'" [selectionPossibilities]="$tilingPossibilities()"></cm-value-slot>
        <cm-value-slot [node]="$node()" [key]="'denoiseTiling'" [label]="'Denoise Tiling'" [selectionPossibilities]="$tilingPossibilities()"></cm-value-slot>
    </ng-container>
</cm-inspector-section>
